const loadBtn = document.querySelector('.blog__load-more a');
const postsWrapper = document.getElementById('posts-wrapper');

function loadMorePosts(url) {
    loadBtn.classList.add('is-loading');
    const request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onreadystatechange = processResponse;
    request.send();

    function processResponse() {
        if (request.readyState != 4) return;
            const resp = request.responseText;
            const parser = new DOMParser();
            const html = parser.parseFromString(resp,"text/html");
            const newPosts = html.getElementById('posts-wrapper').innerHTML;
            postsWrapper.innerHTML += newPosts;

            const nextPosts = html.querySelector('.blog__load-more a');
            if (nextPosts) {
                const nextPostsUrl = nextPosts.href;
                loadBtn.setAttribute('href', nextPostsUrl);
            } else {
                loadBtn.classList.add('d-none');
            }
            loadBtn.classList.remove('is-loading');
        }
}



if (loadBtn) {
    loadBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const thisUrl = e.target.href;
        loadMorePosts(thisUrl);
        return false;
    });
}